import React, { Component } from "react";
import { Row, Col } from "reactstrap";
import { makeRequestAuth } from "../../utils/globals";
import ProfileService from "../../services/profileService";
import TransactionService from "../../services/transactionService";
import TemplateModal from "./TemplateModal";
import { NotificationManager } from "react-notifications";
import ImageLoader from "../ImageLoader";
import { USER_MSG_CHAR_LIMIT } from "../../constants/XoxoCodeCampaignConstants";
import config from "config";
import {
  DesktopIcon,
  DesktopIconFilled,
  EditPencil,
  InfoIcon,
  MobileIcon,
  MobileIconFilled,
} from "../Icons";
import EditLogoModal from "./EditLogoModal";
import EditBtnTextModal from "./EditBtnTextModal";
import EditMsgTextModal from "./EditMsgTextModal";
import TemplatePreview from "./components/TemplatePreview";
import EmailFooter from "./components/EmailFooter";
import LogoPreview from "./components/LogoPreview";
import XoxoLinkRewardBody from "./components/XoxoLinkRewardBody";
import XoxoCodeRewardBody from "./components/XoxoCodeRewardBody";
import XoxoPointRewardBody from "./components/XoxoPointRewardBody";
import PlumProRewardBody from "./components/PlumProRewardBody";
import { getHowToUseLinks } from "./components/constants";

import {
  Button,
  Input,
  Icon,
  Typography,
  CircularLoader,
  Card,
} from "@plum-xoxo/admin-dsm";
import theme from "../../theme";
import styled from "styled-components";
import Templates from "../../modules/Templates";

const DEFAULT_TEMPLATE = {
  album_id: 1,
  album_name: "Default",
  image_url:
    "http://xoxoday-testing.s3.amazonaws.com/store/template/default/e-gift-card-default.jpg",
  image_id: 1,
  company_id: "",
};

const CustomEditDiv = styled(Typography).attrs()`
  background-color: ${(props) => props.theme.palette.background.c00};
  border-radius: ${(props) => props.theme.borderRadius.tertiary}px;
  box-shadow: 0px 8px 20px 1px rgba(54, 42, 102, 0.1);
`;

const BorderDiv = styled(Typography).attrs()`
  position: absolute;
  border: ${(props) => `1px solid ${props.theme.palette.primary.c02}`};
  width: 100%;
  left: 0px;
  &:hover {
    display: unset !important;
    padding: 0px !important;
  }
`;

const StyledCard = styled(Card).attrs()`
  background: ${(props) => props.theme.palette.light.c100};
  border: 1px solid ${(props) => props.theme.palette.light.c300};
`;
class NewEmailPreview extends Component {
  constructor(props) {
    super(props);
    this.state = {
      editMessage: false,
      templateModal: false,
      editSubject: false,
      editHeading: false,
      cardImages: [],
      loader: false,
      maxLimit: 100,
      uploadingLogo: false,
      editButtonText: false,
      isInvalid: false,
      categoryList: [],
      selectedCategory: "",
      openLogoUploadModal: false,
      isDesktopPreview: true,
      openBtnTextModal: false,
      openMsgTextModal: false,
    };
  }

  componentDidMount() {
    this.getPlatformSetting();
    this.fetchAlbumCategory();
  }

  fetchAlbumCategory = () => {
    this.setState({ loader: true });
    ProfileService.fetchAlbumCategory()
      .then((response) => {
        if (
          response &&
          response.data &&
          response.data.fetchCategoryList &&
          response.data.fetchCategoryList.error == false &&
          response.data.fetchCategoryList.data.length > 0
        ) {
          let categoryList = response.data.fetchCategoryList.data;
          categoryList.sort((a, b) =>
            a.category_name > b.category_name
              ? 1
              : b.category_name > a.category_name
              ? -1
              : 0
          );
          categoryList.splice(0, 0, { category_id: 0, category_name: "All" });
          let selectedCategory = categoryList[0];
          this.setState(
            { categoryList, selectedCategory, loader: false },
            () => {
              // this.getCardImages();
              this.getInitialAlbum();
            }
          );
        } else {
          this.setState({ categoryList: [], loader: false });
        }
      })
      .catch((err) => {
        console.log("error", err);
      });
  };

  togglePreviewMode = () => {
    const { isDesktopPreview } = this.state;
    this.setState({ isDesktopPreview: !isDesktopPreview });
  };

  toggleLogoModal = () => {
    const { openLogoUploadModal } = this.state;
    this.setState({ openLogoUploadModal: !openLogoUploadModal });
  };

  toggleTextModal = () => {
    const { openBtnTextModal } = this.state;
    this.setState({ openBtnTextModal: !openBtnTextModal });
  };

  toggleMsgTextModal = () => {
    const { openMsgTextModal } = this.state;
    this.setState({ openMsgTextModal: !openMsgTextModal });
  };

  getInitialAlbum = () => {
    let promises = [];
    let { selectedTemplate } = this.props;
    let { cardImages } = this.state;
    promises.push(TransactionService.getCardImages({ all_category: 1 }));
    promises.push(TransactionService.getCardImages({ all_category: 2 }));
    this.setState({ loader: true });
    Promise.all(promises)
      .then((response) => {
        let finalAlbum = [];
        if (
          response[0] &&
          response[0].fetchAlbumList &&
          response[0].fetchAlbumList.data &&
          response[1] &&
          response[1].fetchAlbumList &&
          response[1].fetchAlbumList.data
        ) {
          finalAlbum = [
            ...response[0].fetchAlbumList.data,
            ...response[1].fetchAlbumList.data,
          ];
          cardImages = response[0].fetchAlbumList.data;
          finalAlbum.map((image) => {
            if (image.image_id === selectedTemplate.image_id) {
              image.selected = true;
              selectedTemplate = image;
            } else {
              image.selected = false;
            }
          });
          this.props.updateState &&
            this.props.updateState({ selectedTemplate });
          // this.props.setSelectedTemplate &&
          //   this.props.setSelectedTemplate(selectedTemplate);
        }
      })
      .catch((err) => {
        console.log("err", err);
      })
      .then(() => {
        this.setState({ loader: false, cardImages });
      });
  };

  getCardImages = (params = { all_category: 1 }) => {
    this.setState({ loader: true });
    const albumReq = "storesAdmin.query.template_fetch_album";
    const cardImagesQuery = {
      query: albumReq,
      tag: "storeAdmin",
      variables: {
        cat_data: {
          ...params,
        },
      },
    };
    let cardImages = [];
    makeRequestAuth(
      cardImagesQuery,
      function (response) {
        if (response && response.data.fetchAlbumList.data) {
          cardImages = response.data.fetchAlbumList.data;
          cardImages.map((item) => {
            item.selected = false;
          });
        }
        this.setState(
          {
            cardImages,
            loader: false,
          },
          () => {
            this.getSelectedTemplate();
          }
        );
      }.bind(this)
    );
  };

  deleteCardImage = (image_id) => {
    let { selectedTemplate } = this.props;
    if (selectedTemplate.image_id === image_id) {
      NotificationManager.warning(
        "This banner is in use and cannot be deleted."
      );
      return;
    }
    this.setState({ loader: true });
    const deleteRequest = "storesAdmin.query.delete_template_image";
    const deleteImagesQuery = {
      query: deleteRequest,
      tag: "storeAdmin",
      variables: {
        img_id: image_id,
      },
    };

    makeRequestAuth(
      deleteImagesQuery,
      function (response) {
        if (response && response.data.deleteTemplateImage.error === false) {
          NotificationManager.success(
            response.data.deleteTemplateImage.message[0]
          );
        } else {
          NotificationManager.error(
            response.data.deleteTemplateImage.message[0]
          );
        }
        this.setState({ loader: false }, () => this.handleCategory());
      }.bind(this)
    );
  };

  getSelectedTemplate = () => {
    let { selectedTemplate } = this.props;
    const { cardImages } = this.state;
    cardImages.map((image) => {
      if (image.image_id === selectedTemplate.image_id) {
        image.selected = true;
        selectedTemplate = image;
      }
    });
    if (!selectedTemplate) {
      selectedTemplate = JSON.parse(JSON.stringify(DEFAULT_TEMPLATE));
    }
    this.props.updateState({ selectedTemplate });
  };

  getPlatformSetting = () => {
    let fetchData = {
      urlPrefix: "",
    };
    ProfileService.getPlatformSetting(fetchData)
      .then((response) => {
        let res = (response && response.fetchPlatformSetting) || {};
        if (res.success == 1 && res.data) {
          this.setState({ platformSetting: res.data });
        }
      })
      .catch((error) => {
        console.log("error", error);
      });
  };

  handleCategory = (selectedCategory = this.state.selectedCategory) => {
    const category_id = selectedCategory.category_id;
    this.setState({ selectedCategory });
    let params = {};
    if (category_id === 0) {
      params.all_category = 1;
    } else if (category_id == 5000) {
      params.all_category = 2;
    } else {
      params.category_id = category_id;
    }
    this.getCardImages(params);
  };

  toggleTemplateModal = () => {
    const { categoryList } = this.state;
    this.setState(
      {
        templateModal: !this.state.templateModal,
        selectedCategory: categoryList[0],
      },
      () => {
        this.handleCategory();
      }
    );
  };

  handleMessage = (event) => {
    if (
      event.target.value &&
      event.target.value.toString().length > USER_MSG_CHAR_LIMIT
    ) {
      return;
    }
    this.props.updateState({ emailMessgae: event.target.value });
  };

  handleHeading = (event) => {
    this.props.updateState({ emailHeading: event.target.value });
  };

  handleSubject = (event) => {
    this.props.updateState({ emailSubject: event.target.value });
  };
  handleTextUpdate = (text) => {
    this.setState({
      openBtnTextModal: false,
    });
    this.props.updateState({ buttonText: text });
  };

  handleUpdateEmailHeading = (text) => {
    this.props.updateState({ emailHeading: text });
    this.setState({ openMsgTextModal: false });
  };

  toggleEditMessage = () => {
    this.setState((prevState) => {
      return {
        ...prevState,
        editMessage: !prevState.editMessage,
      };
    });
  };

  toggleEditHeading = () => {
    this.setState((prevState) => {
      return {
        ...prevState,
        editHeading: !prevState.editHeading,
      };
    });
  };

  toggleEditSubject = () => {
    this.setState((prevState) => {
      return {
        ...prevState,
        editSubject: !prevState.editSubject,
      };
    });
  };

  renderRewardSection = () => {
    const {
      useCase = "",
      denomination_val,
      validTill,
      selectedDate,
      currencyCode = "INR",
    } = this.props;
    const { isDesktopPreview, platformSetting } = this.state;
    if (useCase === "link-campaign" || useCase === "link-distribution") {
      return (
        <XoxoLinkRewardBody
          selectedValue={denomination_val}
          validTill={validTill}
          selectedDate={selectedDate}
          isDesktopPreview={isDesktopPreview}
        />
      );
    } else if (useCase === "code-campaign" || useCase === "code-distribution") {
      return (
        <XoxoCodeRewardBody
          selectedValue={denomination_val}
          validTill={validTill}
          selectedDate={selectedDate}
          currencyCode={currencyCode}
          isDesktopPreview={isDesktopPreview}
        />
      );
    } else if (useCase === "points-distribution") {
      return (
        <XoxoPointRewardBody
          selectedValue={denomination_val}
          validTill={validTill}
          selectedDate={selectedDate}
          isDesktopPreview={isDesktopPreview}
          platformSetting={platformSetting}
        />
      );
    } else if (useCase === "plum-pro-distribution") {
      return (
        <PlumProRewardBody
          selectedValue={denomination_val}
          validTill={validTill}
          selectedDate={selectedDate}
          currencyCode={currencyCode}
          isDesktopPreview={isDesktopPreview}
        />
      );
    }
  };

  renderEmailBody = () => {
    const { isDesktopPreview } = this.state;
    const { useCase = "", emailHeading, isEditDisabled = false } = this.props;
    const editBtnStyle = {
      top: "50%",
      transform: "translate(0, -50%)",
    };
    const distributionLayout = (className) => {
      return (
        <div className={className}>
          <span>{emailHeading}</span>
          {!isEditDisabled ? (
            <div
              className={`overlayBanner align-items-center justify-content-center ${
                isDesktopPreview ? "px-3" : ""
              }`}
            >
              <div className="mr-2">
                <InfoIcon />
              </div>
              <div>
                Message to the recipient will overwrite the default message
                here.
              </div>
            </div>
          ) : null}
        </div>
      );
    };
    switch (useCase) {
      case "link-campaign": {
        return (
          <div className="linkCampaignEmailBody">
            <span>{emailHeading}</span>
            {!isEditDisabled ? (
              <EditMask
                top="10px"
                toggleModalState={() => this.toggleMsgTextModal()}
                buttonText="Message"
                className="mb-4"
                // editBtnStyle={editBtnStyle}
              />
            ) : null}
          </div>
        );
      }
      case "link-distribution": {
        return (
          <div className="linkDistributionEmailBody">
            <span>{emailHeading}</span>
            {!isEditDisabled ? (
              <div className="overlayBanner align-items-center justify-content-center">
                <div className="mr-2">
                  <InfoIcon />
                </div>
                <div>
                  Message to the recipient will overwrite the default message
                  here.
                </div>
              </div>
            ) : null}
          </div>
        );
      }
      case "code-campaign": {
        return (
          <div className="codeCampaignEmailBody">
            <span>{emailHeading}</span>
            {!isEditDisabled ? (
              <EditMask
                top="12px"
                toggleModalState={() => this.toggleMsgTextModal()}
                editBtnStyle={editBtnStyle}
                buttonText="Message"
              />
            ) : null}
          </div>
        );
      }
      case "points-distribution": {
        return distributionLayout("pointsDistributionEmailBody");
      }
      case "code-distribution": {
        return distributionLayout("codeDistributionEmailBody");
      }
      case "plum-pro-distribution": {
        return distributionLayout("plumProDistributionEmailBody");
      }
      default:
        null;
    }
  };

  onSearch = (query) => {
    this.setState({ loader: true });

    let payload = {
      all_category: 1,
      album_name: query,
    };

    const albumReq = "storesAdmin.query.template_fetch_album";

    const request_data = {
      query: albumReq,
      tag: "storeAdmin",
      variables: {
        cat_data: payload,
      },
    };

    let cardImages = [];
    makeRequestAuth(
      request_data,
      function (response) {
        if (response && response.data.fetchAlbumList.data) {
          cardImages = response.data.fetchAlbumList.data;
          cardImages.map((item) => {
            item.selected = false;
          });
        }

        /**
         * {
            category_id: 0,
            category_name: "All",
          }
         */
        let stateData = {
          cardImages,
          selectedCategory: {},
          loader: false,
        };

        this.setState(stateData, () => {
          this.getSelectedTemplate();
        });
      }.bind(this)
    );
  };

  renderInfo = () => {
    const { useCase = "" } = this.props;
    let text = "";
    if (useCase === "code-distribution" || useCase === "code-campaign") {
      if (useCase === "plum-pro-distribution") text = "quantity";
      else text = "no. of codes";
      return (
        <div className="mt-40 d-flex align-items-center">
          <Icon iconName="Info" color="blue" shade="c200" size="m" />
          <Typography
            component="span"
            className="ml-2 mb-0"
            color="dark"
            shade="c300"
          >
            If there are more than five '{text}', we add them to the email as
            attachments.
          </Typography>
        </div>
      );
    }
  };

  render() {
    const {
      templateModal,
      cardImages,
      loader,
      maxLimit,
      uploadingLogo,
      categoryList,
      selectedCategory,
      isDesktopPreview,
      openLogoUploadModal,
      openBtnTextModal,
      openMsgTextModal,
    } = this.state;
    const {
      company_primary_logo,
      selectedTemplate, // the default template user
      site_id,
      emailHeading,
      emailSubject,
      useCase = "",
      buttonText = "Redeem now",
      isEditDisabled = false,
      isPreview = false,
    } = this.props;
    return (
      <>
        <div className="row email-preview  justify-content-start">
          {!isPreview ? (
            <>
              <div className="col-12">
                <Input
                  label="Subject"
                  limit={maxLimit}
                  value={emailSubject}
                  onChange={this.handleSubject}
                  placeholder={emailSubject}
                  disabled={isEditDisabled}
                  required
                  error={emailSubject?.length === 0 ? true : false}
                  className="mt-24"
                  helperText={
                    emailSubject?.length === 0
                      ? "Email subject cannot be left blank."
                      : ""
                  }
                  style={{
                    backgroundColor: theme.palette.common.white,
                  }}
                />
              </div>
            </>
          ) : null}

          <div className={`col-12 ${!isPreview && "mt-12"}`}>
            <StyledCard spaceAround={6} shadow={false} className="p-20">
              <div className="emailTempBckground">
                {!isPreview && (
                  <>
                    <div className="col-12 pl-0">
                      <Typography.LabelText
                        className="text-left mb-4"
                        color="dark"
                        shade="c300"
                      >
                        Choose Email Template
                      </Typography.LabelText>
                      <Typography.BodySmall
                        className="text-left mb-4"
                        color="dark"
                        shade="c200"
                      >
                        Choose from an email template in which the reward will
                        be sent.
                      </Typography.BodySmall>
                      <Templates
                        isEdit={true}
                        accountReducer={this.props.accountReducer}
                        updateState={this.props.updateState}
                        useCase={useCase}
                        selectedTemplate={selectedTemplate}
                        selectedDate={this.props.selectedDate}
                        currencyCode={this.props.currencyCode}
                        denomination_val={this.props.denomination_val}
                        validTill={this.props.validTill}
                      />
                    </div>
                    <hr className="mt-48" />

                    {/* <div className="col-12">
                      <Typography.LabelText className="text-left mt-28 mb-4">
                        Preview
                      </Typography.LabelText>
                    </div> */}
                  </>
                )}
                {!isEditDisabled || isPreview ? (
                  <div className="previewMode ml-auto">
                    <PreviewModes
                      isDesktopPreview={isDesktopPreview}
                      handleChangePreview={this.togglePreviewMode}
                    />
                  </div>
                ) : null}
                <div
                  className={`emailTemplateSection border1 p-0 my-0 mx-auto bg-white ${
                    !isDesktopPreview ? "mobile" : ""
                  }`}
                >
                  <Row className="justify-content-center">
                    <Col xs="12">
                      {uploadingLogo ? (
                        <div className="d-flex justify-content-center align-items-center">
                          <CircularLoader />
                        </div>
                      ) : (
                        <div className="logoSection position-relative">
                          {!isEditDisabled ? (
                            <EditMask
                              buttonText="Logo"
                              toggleModalState={() => this.toggleLogoModal()}
                            />
                          ) : null}
                          <LogoPreview imgSrc={company_primary_logo} />
                        </div>
                      )}
                    </Col>
                  </Row>
                  <Row className="justify-content-center">
                    <Col xs="12">
                      {loader && isPreview && !selectedTemplate?.img_path ? (
                        <div className="d-flex justify-content-center align-items-center">
                          <CircularLoader />
                        </div>
                      ) : (
                        <div className="position-relative mailBannerImage">
                          {!isEditDisabled && !isPreview ? (
                            <EditMask
                              buttonText="Banner"
                              height={isDesktopPreview ? "300px" : "188px"}
                              toggleModalState={() =>
                                this.toggleTemplateModal()
                              }
                            />
                          ) : null}
                          <TemplatePreview
                            imgSrc={
                              selectedTemplate?.img_path
                                ? config.album_image_s3_url +
                                  selectedTemplate?.img_path
                                : selectedTemplate.image_url
                            }
                          />
                        </div>
                      )}
                    </Col>
                  </Row>
                  <Row>
                    <Col xs="12">
                      <div className="position-relative pt-28 px-32 ">
                        {useCase === "code-campaign" ||
                        useCase === "code-distribution" ||
                        useCase === "points-distribution" ? (
                          <div style={{ marginBottom: "12px" }}>
                            <span className="inkNormal">Hi</span>{" "}
                            <span className="inkLight">
                              {`{recipient-name}`},
                            </span>
                          </div>
                        ) : null}

                        {useCase === "plum-pro-distribution" ? (
                          <div style={{ marginBottom: "12px" }}>
                            <span className="inkNormal">Hi,</span>
                          </div>
                        ) : null}
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col xs="12">
                      <div className="position-relative py-24 px-32 ">
                        {/* {useCase === "code-campaign" ||
                      useCase === "code-distribution" ||
                      useCase === "points-distribution" ? (
                        <div style={{ marginBottom: "12px" }}>
                          <span className="inkNormal">Hi</span>{" "}
                          <span className="inkLight">
                            {`{recipient-name}`},
                          </span>
                        </div>
                      ) : null}

                      {useCase === "plum-pro-distribution" ? (
                        <div style={{ marginBottom: "12px" }}>
                          <span className="inkNormal">Hi,</span>
                        </div>
                      ) : null} */}
                        <div className="inkNormal emailBody">
                          {this.renderEmailBody()}
                        </div>
                      </div>
                    </Col>
                  </Row>
                  <Row className="justify-content-center mt-12">
                    <Col xs={12}>{this.renderRewardSection()}</Col>
                  </Row>
                  <Row
                    className={`rewardBtnSection ${
                      !isDesktopPreview ? "mobile" : ""
                    }`}
                  >
                    <Col xs={12}>
                      <div
                        className="position-relative btnDiv"
                        style={{ textAlign: "center" }}
                      >
                        <Button className="cursor-default">{buttonText}</Button>
                        {!isEditDisabled ? (
                          <EditMask
                            buttonText="Button Text"
                            editBtnStyle={{
                              top: "50%",
                              transform: "translate(0, -50%)",
                            }}
                            toggleModalState={() => this.toggleTextModal()}
                          />
                        ) : null}
                      </div>
                    </Col>
                  </Row>
                  <EmailFooter
                    isDesktopPreview={isDesktopPreview}
                    getHowToUseLinks={getHowToUseLinks}
                    useCase={useCase}
                  />
                </div>

                <div className="d-flex justify-content-center">
                  {!isPreview && this.renderInfo()}
                </div>
              </div>
            </StyledCard>
          </div>
        </div>
        {templateModal ? (
          <TemplateModal
            site_id={site_id}
            cardImages={cardImages}
            loader={loader}
            getCardImages={this.getCardImages}
            callbackMethod={this.toggleTemplateModal}
            updateState={this.props.updateState}
            deleteCardImage={(img_id) => this.deleteCardImage(img_id)}
            categoryList={categoryList}
            selectedCategory={selectedCategory}
            handleCategory={this.handleCategory}
            selectedTemplate={selectedTemplate}
            onSearch={this.onSearch}
          />
        ) : null}
        {openLogoUploadModal ? (
          <EditLogoModal
            toggleModal={() => this.setState({ openLogoUploadModal: false })}
            logoSrc={company_primary_logo}
            setNewLogo={(logoUrl) =>
              this.props.updateState({ emailLogo: logoUrl })
            }
          />
        ) : null}

        {openBtnTextModal ? (
          <EditBtnTextModal
            toggleModal={() => this.setState({ openBtnTextModal: false })}
            buttonText={buttonText}
            updateBtnText={(text) => this.handleTextUpdate(text)}
          />
        ) : null}

        {openMsgTextModal ? (
          <EditMsgTextModal
            toggleModal={() => this.setState({ openMsgTextModal: false })}
            updateEmailMsgText={(text) => this.handleUpdateEmailHeading(text)}
            emailHeading={emailHeading}
          />
        ) : null}
      </>
    );
  }
}

const PreviewModes = ({ isDesktopPreview, handleChangePreview }) => {
  return (
    <div className="d-flex align-items-center justify-content-center previewOptions">
      <div
        onClick={handleChangePreview}
        className={
          isDesktopPreview
            ? `pointer systemLayout active`
            : `pointer systemLayout`
        }
      >
        {isDesktopPreview ? <DesktopIconFilled /> : <DesktopIcon />}
        {/* <span className="ml-8">Desktop</span> */}
      </div>
      <div
        onClick={handleChangePreview}
        className={
          !isDesktopPreview
            ? `pointer systemLayout active`
            : `pointer systemLayout`
        }
      >
        {!isDesktopPreview ? <MobileIconFilled /> : <MobileIcon />}

        {/* <span className="ml-8">Mobile</span> */}
      </div>
    </div>
  );
};

const EditMask = ({
  height = null,
  toggleModalState,
  top = null,
  editBtnStyle = null,
  buttonText,
}) => {
  return (
    <BorderDiv
      className={`showMask ${!height ? "h-100" : ""}`}
      style={{ height, top }}
    >
      <div className="d-flex align-items-center justify-content-end pr-24 mt-16">
        <CustomEditDiv className="d-flex justify-content-center align-items-center">
          <Button
            onClick={toggleModalState}
            variant="plain"
            color="common"
            shade="white"
            startIcon={
              <Icon color="primary" iconName="Edit" shade="c02" size="16" />
            }
          >
            <Typography.ButtonText color="primary" shade="c02" className="ml-8">
              Edit {buttonText}
            </Typography.ButtonText>
            {/* <span className="cursor-pointer">
        </span> */}
          </Button>
        </CustomEditDiv>
      </div>
    </BorderDiv>
  );
};

export default NewEmailPreview;
